const sourceList = ['automatic_messages', 'campaign','client_portal', 'initiated_by_staff','staff_initiated', 'website', 'text_to_business_phone', 'promotions_opt-in_by_keyword', 'forward', 'invitation', 'google_reserve'].reduce( (acc, name) => {
  acc[name] = name;
  return acc;
}, {});

export default {
  sourceList
}
